<template>
  <div class="content4 content8 contentPage swiper-slide" :class="nowPage === 7 ? 'cartoon' : ''">
    <div class="animalNav" :style="{display: showNow === 0 ? 'flex' : 'none'}">
      <div class="leftTxtWrap">
        <img :src="txtImg" class="txtImg"/>
        <div class="heng"></div>
        <img :src="titleImg" class="titleImg"/>
        <div class="txtInfo">今鸟型类包括了部分古鸟类和所有的现生鸟类，分布遍及全球。它们具有许多有利于飞行的进步特征，比如：颈椎和脊椎为异凹型，肩胛骨与乌喙骨连接形成的肱骨关节面向外，胸骨具较发育的龙骨突，股骨比胫骨短等。</div>
        <div class="btnWrap">
          <animalBtn 
            v-for="item in btnList" 
            :key="item.id" 
            :cnTitle='item.cnTitle' 
            :enTitle='item.enTitle'
            @click.native="changeShowAnimal(item.id)"
          ></animalBtn>
        </div>
      </div>
      <div class="rightImgWrap">
        <moveImg :imgSrc='rightAni' class="rightAni"></moveImg>
      </div>
    </div>

    <categoryAnimal 
      :animalType='martiniAnimal.animalType' 
      :animalTypeEn='martiniAnimal.animalTypeEn'
      :categoryTxt='martiniAnimal.categoryTxt'
      :categoryInfoImg='martiniAnimal.categoryInfoImg'
      :showList='martiniAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 1"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='gansusAnimal.animalType' 
      :animalTypeEn='gansusAnimal.animalTypeEn'
      :categoryTxt='gansusAnimal.categoryTxt'
      :categoryInfoImg='gansusAnimal.categoryInfoImg'
      :showList='gansusAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 2"
    ></categoryAnimal>
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'

import txtImg from '@/assets/img/content8/txtImg.png'
import titleImg from '@/assets/img/content8/titleImg.png'
import rightAni from '@/assets/img/content8/rightAni.png'

import { btnList, martiniAnimal, gansusAnimal } from './data'


export default {
  mixins: [swiperMixin],
  data () {
    return {
      txtImg,
      titleImg,
      rightAni,
      showNow: 0, // 当前展示的是第几个
      btnList,
      martiniAnimal, // 马氏燕鸟
      gansusAnimal, // 甘肃鸟
    }
  },
  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },
  watch: {
    nowPage ( nowPage ) {
      if ( nowPage === 7 && this.showNow > 0 ) {
        this.showNow = 0
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import '../content4/content4.styl'
@import './content8.styl'
</style>